import store from '../../../reducers/storeRegistration';
import notificationActions from '../../../actions/notificationActionCreators';
const message = (messageType, entryTypeVal, callback) => {
  const entryType = typeof entryTypeVal === 'string' ? entryTypeVal : 'entry';
  store.dispatch(notificationActions.info({
    headerMessage: `Are you sure you would like to ${messageType} this ${entryType}?`,
    rightButtonLabel: 'Yes',
    rightButtonAction: callback,
    leftButtonLabel: 'No',
    id: `${messageType}_item_confirm`
  }, {
    autoClose: false
  })); // need a user response, even if it's to cancel

  return null;
};

// check to see if cofirmation is requires. i.e. there is any data set in the object
const requiresConfirmation = (data, fieldsToCheck) => {
  let confirmRequired = false;
  if (fieldsToCheck && Array.isArray(fieldsToCheck)) {
    fieldsToCheck.forEach(field => {
      if (typeof data[field] !== 'undefined' && data[field] !== null && data[field] !== '') {
        // If the field is an array, only remove it if there are no elements
        if (!Array.isArray(data[field]) || data[field].length) {
          confirmRequired = true;
        }
      }
    });
  }
  return confirmRequired;
};

// invoke callback if no confirmation is required or user confirms removal
export const removeItemWithConfirm = (data, entryTypeVal, fieldsToCheck, callback) => {
  const confirmRemove = requiresConfirmation(data, fieldsToCheck);
  if (!confirmRemove) {
    return callback();
  }
  return message('remove', entryTypeVal, callback);
};

// invoke callback if no confirmation is required or user confirms change
export const changeItemWithConfirm = (data, entryTypeVal, fieldsToCheck, callback) => {
  const confirmRemove = requiresConfirmation(data, fieldsToCheck);
  if (!confirmRemove) {
    return callback();
  }
  return message('change', entryTypeVal, callback);
};